import React, { Component } from 'react'

const randomstring = "?" + Math.random().toString(36).substring(1);

export const GenerateString = randomstring;
